import { AiSnippet } from './ai-snippet.model';

export class AiQASearchHistory {
  searches: AiQASearch[];
  projectId: number;
  createdAt: string;
  updatedAt: string;
}

export class AiQASearch {
  id: string;
  questionText: string;
  answer: string;
  snippets: AiSnippet[];
  createdAt: string;
  createdBy: string;
  replies?: AiQASearch[];
}
